import React from 'react';

export interface StepIdentityProps {
  name: string;
  onNameChange: (v: string) => void;
  nameError: string;
  nameAvailability: 'idle' | 'checking' | 'available' | 'taken';
  description: string;
  onDescriptionChange: (v: string) => void;
  descriptionError: string;
  dataVersion: string;
  onDataVersionChange: (v: string) => void;
  dataVersionError: string;
}

const StepIdentity: React.FC<StepIdentityProps> = ({
  name, onNameChange, nameError, nameAvailability,
  description, onDescriptionChange, descriptionError,
  dataVersion, onDataVersionChange, dataVersionError,
}) => {
  const slugPreview = name.trim()
    ? `?_${name.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '')}`
    : null;

  const availHint = () => {
    if (nameAvailability === 'checking') return <span className="wiz-field-hint">Checking...</span>;
    if (nameAvailability === 'available') return <span className="wiz-field-hint wiz-field-hint--ok">Available</span>;
    if (nameAvailability === 'taken') return <span className="wiz-field-hint wiz-field-hint--err">Name already in use</span>;
    return null;
  };

  return (
    <div className="wiz-step-identity">
      {/* KG Name */}
      <div className="wiz-field">
        <label className="wiz-label">
          KG name <span className="wiz-required">Required</span>
        </label>
        <input
          className={`wiz-input${nameError || nameAvailability === 'taken' ? ' wiz-input--error' : ''}`}
          type="text"
          value={name}
          onChange={e => onNameChange(e.target.value)}
          placeholder="e.g. EchoMap, BaseKG"
          autoFocus
          autoComplete="off"
        />
        {nameError
          ? <span className="wiz-field-error">{nameError}</span>
          : availHint()
        }
        {slugPreview && !nameError && (
          <span className="wiz-field-hint wiz-field-hint--mono">ID will be: {slugPreview}</span>
        )}
      </div>

      {/* Description */}
      <div className="wiz-field">
        <label className="wiz-label">
          Description <span className="wiz-required">Required</span>
        </label>
        <textarea
          className={`wiz-textarea${descriptionError ? ' wiz-textarea--error' : ''}`}
          value={description}
          onChange={e => onDescriptionChange(e.target.value)}
          placeholder="Short description of this knowledge graph"
          rows={3}
        />
        {descriptionError && <span className="wiz-field-error">{descriptionError}</span>}
      </div>

      {/* Data version */}
      <div className="wiz-field">
        <label className="wiz-label">
          Data version <span className="wiz-required">Required</span>
        </label>
        <input
          className={`wiz-input${dataVersionError ? ' wiz-input--error' : ''}`}
          type="text"
          value={dataVersion}
          onChange={e => onDataVersionChange(e.target.value)}
          placeholder="e.g. v1.0.0"
          autoComplete="off"
        />
        {dataVersionError
          ? <span className="wiz-field-error">{dataVersionError}</span>
          : <span className="wiz-field-hint">Any string works — we suggest <strong>v1.0.0</strong> format</span>
        }
      </div>
    </div>
  );
};

export default StepIdentity;
